/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Budget_QInputs */

const en_mk_faq_budget_q = /** @type {(inputs: Mk_Faq_Budget_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are token and cost limits always exact?`)
};

const id_mk_faq_budget_q = /** @type {(inputs: Mk_Faq_Budget_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah batas token dan biaya selalu tepat?`)
};

/**
* | output |
* | --- |
* | "Are token and cost limits always exact?" |
*
* @param {Mk_Faq_Budget_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_budget_q = /** @type {((inputs?: Mk_Faq_Budget_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Budget_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_budget_q(inputs)
	return en_mk_faq_budget_q(inputs)
});